export default __webpack_public_path__ + "static/media/banner.15630ecd.jpg";